(function () {
  var CLOSE_DELAY = 250;

  function setupHoverIntent(selector, openClass) {
    document.querySelectorAll(selector).forEach(function (item) {
      var closeTimer = null;

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        item.classList.add(openClass);
      });

      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          item.classList.remove(openClass);
        }, CLOSE_DELAY);
      });
    });
  }

  setupHoverIntent('.fw-nav__item--has-mega', 'fw-nav__item--open');
  setupHoverIntent('.fw-nav__cat-item', 'fw-nav__cat-item--open');
})();
